export class KeyPrefixHelper {
    constructor(prefix) {
        this.prefix = prefix !== null && prefix !== void 0 ? prefix : '';
    }
    matchPrefix(key) {
        return key.startsWith(this.prefix);
    }
    appendPrefix(key) {
        return `${this.prefix}${key}`;
    }
    removePrefix(key) {
        return key.slice(this.prefix.length);
    }
}
export const defaultPrefix = '@fetcher:';
